<template>
  <div>
    <v-row no-gutters>
      <v-col cols="12" class="mr-2 mt-2">
        <v-card elevation="0" height="92vh" class="main-dashboard-115-card body-card">
          <v-card-text>
            <v-row no-gutters>
              <v-col cols="12">
                <v-row>
                  <v-col class="dash-top-item-space">
                    <v-row>
                      <v-col cols="4">
                        <v-card height="15vh" class="data-card1" elevation="0">
                          <v-card-text>
                            <v-row no-gutters>
                              <v-col cols="2">
                                <v-icon color="darkColor" class="data-card-icon">
                                  mdi-clock-time-four mdi-18px
                                </v-icon>
                              </v-col>
                              <v-col cols="3">
                                <h2 class="data-card-title pr-2">ساعت کاری</h2>
                              </v-col>
                              <v-spacer></v-spacer>
                              <v-col cols="5" class="ml-n5">
                                <h2 class="data-card-content">
                                  {{ dashboard115Time }}
                                </h2>
                              </v-col>
                            </v-row>
                          </v-card-text>
                        </v-card>
                      </v-col>
                      <v-col cols="4">
                        <v-card height="15vh" class="data-card2" elevation="0">
                          <v-card-text>
                            <v-row no-gutters>
                              <v-col cols="2">
                                <v-icon color="darkColor" class="data-card-icon">
                                  mdi-clock-time-four mdi-18px
                                </v-icon>
                              </v-col>
                              <v-col cols="5">
                                <h2 class="data-card-title pr-2">میانگین زمان پاسخگویی</h2>
                              </v-col>
                              <v-spacer></v-spacer>
                              <v-col cols="5" class="ml-n5">
                                <h2 class="data-card-content">
                                  {{ dashboard115TimeCall }}
                                </h2>
                              </v-col>
                            </v-row>
                          </v-card-text>
                        </v-card>
                      </v-col>
                      <v-col cols="4">
                        <v-card height="15vh" class="data-card2" elevation="0">
                          <v-card-text>
                            <v-row no-gutters>
                              <v-col cols="2">
                                <v-icon color="darkColor" class="data-card-icon">
                                  mdi-clock-time-four mdi-18px
                                </v-icon>
                              </v-col>
                              <v-col cols="5">
                                <h2 class="data-card-title pr-2">مدت زمان DND</h2>
                              </v-col>
                              <v-spacer></v-spacer>
                              <v-col cols="5" class="ml-n5">
                                <h2 class="data-card-content">
                                  {{ dashboard115DndDuration }}
                                </h2>
                              </v-col>
                            </v-row>
                          </v-card-text>
                        </v-card>
                      </v-col>
                      <v-col cols="12">
                        <v-card height="18vh" class="detail-115-dashboard-card" elevation="0">
                          <v-row no-gutters>
                            <v-col cols="12">
                              <v-img :src="dashboardIMG" contain class="second-row-img"></v-img>
                            </v-col>
                          </v-row>
                          <v-card-text>
                            <v-row no-gutters>
                              <v-col cols="4">
                                <v-row>
                                  <v-col cols="1"></v-col>
                                  <v-col cols="2">
                                    <v-icon color="lightColor" class="data-card-icon">
                                      mdi-phone mdi-flip-h mdi-18px
                                    </v-icon>
                                  </v-col>
                                  <v-col cols="7">
                                    <v-row>
                                      <v-col cols="12">
                                        <h2 class="data-card-calls-count-content">
                                          {{ dashboard115CallsCount }}
                                        </h2>
                                      </v-col>
                                    </v-row>
                                    <v-row>
                                      <v-col cols="12">
                                        <h2 class="data-card-calls-count-title">تماس ها</h2>
                                      </v-col>
                                    </v-row>
                                  </v-col>
                                </v-row>
                              </v-col>
                              <v-col cols="4">
                                <v-row>
                                  <v-col cols="1"></v-col>
                                  <v-col cols="2">
                                    <v-icon color="lightColor" class="data-card-icon">
                                      mdi-map-marker mdi-18px
                                    </v-icon>
                                  </v-col>
                                  <v-col cols="7">
                                    <v-row>
                                      <v-col cols="12">
                                        <h2 class="data-card-calls-count-content">
                                          {{ dashboard115LocationCount }}
                                        </h2>
                                      </v-col>
                                    </v-row>
                                    <v-row>
                                      <v-col cols="12">
                                        <h2 class="data-card-calls-count-title">
                                          ماموریت های تایید آدرس
                                        </h2>
                                      </v-col>
                                    </v-row>
                                  </v-col>
                                </v-row>
                              </v-col>
                              <v-col cols="4">
                                <v-row>
                                  <v-col cols="1"></v-col>
                                  <v-col cols="2">
                                    <v-icon color="lightColor" class="data-card-icon">
                                      mdi-clipboard-list mdi-18px
                                    </v-icon>
                                  </v-col>
                                  <v-col cols="7">
                                    <v-row>
                                      <v-col cols="12">
                                        <h2 class="data-card-calls-count-content">
                                          {{ dashboard115TriageCount }}
                                        </h2>
                                      </v-col>
                                    </v-row>
                                    <v-row>
                                      <v-col cols="12">
                                        <h2 class="data-card-calls-count-title">
                                          ماموریت های تریاژ شده
                                        </h2>
                                      </v-col>
                                    </v-row>
                                  </v-col>
                                </v-row>
                              </v-col>
                            </v-row>
                          </v-card-text>
                        </v-card>
                      </v-col>
                    </v-row>
                  </v-col>
                  <v-col class="dash-top-item-space2">
                    <v-card height="265px" class="detail-115-dashboard-card" elevation="0">
                      <v-row no-gutters class="chart-title">
                        <v-icon color="white" class="chart-title-icon">mdi-cog mdi-48px</v-icon>
                        <span class="chart-title-content">نتیجه تماس ها</span>
                      </v-row>
                      <v-card-text>
                        <div id="dashboard115PieChart" dir="rtl" style="width: inherit">
                          <highcharts :options="dashboard115PieChartOptions" ref="pie"></highcharts>
                        </div>
                      </v-card-text>
                    </v-card>
                  </v-col>
                  <v-col cols="12">
                    <v-card height="265px" class="detail-115-dashboard-card" elevation="0">
                      <v-row no-gutters class="chart-title">
                        <v-icon color="white" class="chart-title-icon">
                          mdi-clock-time-seven mdi-48px
                        </v-icon>
                        <span class="chart-title-content">تشخیص ها</span>
                      </v-row>
                      <v-card-text>
                        <div id="dashboard115ColumnChart" dir="rtl" style="width: inherit">
                          <highcharts :options="dashboard115ColumnChartOptions" ref="column"></highcharts>
                        </div>
                      </v-card-text>
                    </v-card>
                  </v-col>
                  <v-col cols="12">
                    <v-card height="265px" class="detail-115-dashboard-card" elevation="0">
                      <v-row no-gutters class="chart-title">
                        <v-icon color="white" class="chart-title-icon">
                          mdi-clipboard-list mdi-48px
                        </v-icon>
                        <span class="chart-title-content">تماس ها</span>
                      </v-row>
                      <v-card-text>
                        <div id="dashboard115LineChart" dir="rtl" style="width: inherit">
                          <highcharts :options="dashboard115LineChartOptions" ref="line"></highcharts>
                        </div>
                      </v-card-text>
                    </v-card>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <alert-component ref="snackRef" :snakTimeOut="snakTimeOut" :snackColor="snackColor" :snackText="snackText"
      :snakIcon="snakIcon"></alert-component>
  </div>
</template>
<script>
import AlertComponent from '../../components/AlertComponent.vue';

import Shared from '@/Helpers/Shared';
import DashboardMixin from '@/Mixins/Dashboard/DashboardMixin.js';
import Dashboard115Helper from '@/Helpers/115/Dashboard115Helper.js';
import snackBar from '@/Mixins/snackBar.js';
import ShearedMixin from '@/Mixins/Shared.js';
export default {
  name: 'Dashboard115View',
  title: 'داشبورد 115',
  components: { AlertComponent },
  mixins: [Shared, DashboardMixin, Dashboard115Helper, snackBar, ShearedMixin],
  created() {
    this.$root.$refs.Dashboard115 = this;
  },
  mounted() {
    this.mounteLoding();
  },
  beforeDestroy() {
    clearInterval(this.dashboard115TimeInterval);
    this.dashboard115TimeInterval = null;
  },
  data() {
    return {
      newCall: false,
    };
  },
  methods: {
    mounte: function () {
      this.get115DashboardFunction();
    },
  },
};
</script>
<style scoped>
.main-dashboard-115-card {
  border-radius: 10px !important;
  border: 1px solid var(--dark-color) !important;
}

.body-card {
  overflow: hidden;
}

.body-card:hover {
  overflow-y: auto;
}

.detail-115-dashboard-card {
  background: var(--background-color) !important;
  border-radius: 15px !important;
}

.data-card1 {
  background: linear-gradient(250deg, var(--dark-color) 8%, var(--background-color) 120%);
  border-radius: 15px !important;
}

.data-card2 {
  background: linear-gradient(250deg, var(--light-color) 8%, var(--background-color) 120%);
  border-radius: 15px !important;
}

>>>.highcharts-credits {
  /*color: black !important;*/
  fill: var(--background-color) !important;
  cursor: auto !important;
}

>>>.highcharts-background {
  fill: var(--background-color) !important;
}

>>>.highcharts-legend-item text {
  fill: var(--dark-color) !important;
}

>>>.highcharts-label span {
  fill: var(--dark-color) !important;
  color: var(--dark-color) !important;
  z-index: 1 !important;
}

.card-info-send-mission-scroll {
  overflow-y: auto !important;
  overflow-x: hidden !important;
}

>>>.second-row-img {
  position: absolute;
  margin-top: 2.5vh;
}

.data-card-icon {
  background: white;
  padding: 10px !important;
  border-radius: 50% !important;
  margin-top: 2.5vh;
}

.data-card-title {
  color: white;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  padding-top: 3.3vh !important;
  margin-right: -2vh !important;
}

.data-card-content {
  color: white;
  font-size: 24px;
  font-style: normal;
  font-weight: 700;
  padding-top: 3.5vh !important;
  letter-spacing: 1.3px;
}

.data-card-calls-count-content {
  color: #2d3748;
  font-size: 24px;
  font-style: normal;
  font-weight: 700;
  padding-top: 2vh !important;
  letter-spacing: 1.3px;
  position: relative !important;
}

.data-card-calls-count-title {
  color: #2d3748;
  font-size: 13px;
  font-style: normal;
  font-weight: normal;
  margin-top: -2vh !important;
  position: relative !important;
}

.chart-title {
  position: absolute;
}

.chart-title-content {
  margin-right: -50px;
  margin-top: 8px;
  font-weight: 500;
  font-size: 15px;
  z-index: 1;
  color: var(--dark-color);
}

.chart-title-icon {
  z-index: 1;
  margin-right: 10px;
  margin-top: 4px;
}

.dash-top-item-space {
  width: 74% !important;
  min-width: 74% !important;
  max-width: 74% !important;
}

.dash-top-item-space2 {
  width: 26% !important;
  min-width: 26% !important;
  max-width: 26% !important;
}
</style>
